<template>
  <MSelect
    item-text="iso"
    item-value="iso"
    v-bind="$attrs"
    :label-class="labelClass"
    :selection-class="selectionClass"
    :selection-text-class="selectionTextClass"
    :no-overlay="noOverlay"
    :no-arrow="noArrow"
    placeholder="&nbsp;"
    :filter="filter"
    :filter-by="['iso', 'label']"
    :items="sortedCurrencies"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :popover-class="popoverClass"
    :header-text="headerText"
  >
    <template v-if="showFlag" #selection>
      <span class="flag rounded-4" :class="`flag-${modelValue.toLowerCase()}`" />
      {{ modelValue }}
    </template>
    <template #item="{ item }: { item: Currency }">
      <div class="flex items-center">
        <span v-if="showFlag" class="flag rounded-4" :class="`flag-${item.iso.toLowerCase()}`" />
        <span class="w-12 shrink-0 opacity-80 mr-4">{{ item.iso }}</span>
        <span class="whitespace-normal">{{ item.label }}</span>
      </div>
    </template>
  </MSelect>
</template>

<script lang="ts" setup>
import type { Currency } from './types'

defineEmits(['update:modelValue'])

const props = defineProps<{
  currencies: Currency[]
  modelValue: string
  showFlag?: boolean
  labelClass?: string
  selectionClass?: string
  filter?: boolean
  noOverlay?: boolean
  noArrow?: boolean
  selectionTextClass?: string
  headerText: string
  popoverClass?: string
}>()

const sortedCurrencies = computed(() => {
  return [...props.currencies].sort((a, b) => a.iso.localeCompare(b.iso))
})
</script>
